import {
  getZrmListingInfo,
  getZrmRentalsLead,
  getZrmUserInfo,
  type ZrmClickstreamLead,
  type ZrmClickstreamListing,
} from '@zg-rentals/clickstream';
import { trackListingEvent } from '../../analytics';
import { SEMANTIC_EVENT_NAME, TOPIC_TAG_TXT, TRIGGER_LOCATION, TRIGGER_TYPE } from './globals';
import type { ZrmClickstreamUserOrNull } from '../../analytics/types';

// https://dataportal.zillowgroup.net/event-registry/9263
export const CLICK_SEND_MESSAGE_IN_APPROVE_LEAD_MODAL_EVENT_TYPE_ID = '9263';
export const emitClickSendMessageInApproveLeadModalEvent = (
  user: ZrmClickstreamUserOrNull,
  listing: ZrmClickstreamListing,
  lead?: ZrmClickstreamLead | null,
) =>
  trackListingEvent({
    envelope: {
      event_type_id: CLICK_SEND_MESSAGE_IN_APPROVE_LEAD_MODAL_EVENT_TYPE_ID,
      event_type_version_id: '3',
      event_template_id: '628',
      event_template_version_id: '1',
    },
    clickstream_trigger: {
      trigger_type_nm: TRIGGER_TYPE.Interaction,
      trigger_location_nm: TRIGGER_LOCATION.LeadManagementPage,
      trigger_source_nm: 'send_message_button',
      trigger_object_nm: 'approve_lead_modal',
    },
    semantic: {
      semantic_event_nm: SEMANTIC_EVENT_NAME.ManageLead,
      topic_tag_txt: [TOPIC_TAG_TXT.ZrmSatellite],
    },
    ...getZrmUserInfo(user),
    ...getZrmListingInfo(listing),
    ...getZrmRentalsLead(lead),
  });
